import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { href: '#headlines', label: '热点头条' },
  { href: '#hotlist', label: '话题热榜' },
  { href: '#memes', label: '热梗盘点' },
  { href: '#scene', label: '假期现场' },
  { href: '#faq', label: '吃瓜指南' },
  { href: '#about', label: '关于本站' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 shadow-sm backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex cursor-pointer items-center gap-2"
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full font-heading text-lg leading-none ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-600'
            }`}
          >
            瓜
          </span>
          <span
            className={`font-heading text-xl tracking-wide transition-colors ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            五一爆料
            <span className="ml-1 align-middle text-[10px] font-sans text-accent-500">· 吃瓜不迷路</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((item) => (
            <button
              key={item.href}
              type="button"
              onClick={() => go(item.href)}
              className={`whitespace-nowrap cursor-pointer rounded-full px-4 py-2 text-sm transition-colors ${
                scrolled
                  ? 'text-foreground-800 hover:bg-background-100 hover:text-primary-600'
                  : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => go('#hotlist')}
            className={`whitespace-nowrap hidden cursor-pointer items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors sm:flex ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/95 text-primary-600 hover:bg-background-50'
            }`}
          >
            <i className="ri-fire-line"></i>
            今日热榜
          </button>

          <button
            type="button"
            aria-label="切换菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-full transition-colors lg:hidden ${
              scrolled || menuOpen
                ? 'text-foreground-800 hover:bg-background-100'
                : 'text-background-50 hover:bg-background-50/15'
            }`}
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      <div
        className={`overflow-hidden transition-all duration-300 lg:hidden ${
          menuOpen ? 'max-h-[420px]' : 'max-h-0'
        }`}
      >
        <nav className="mx-4 mb-3 flex flex-col gap-1 rounded-2xl border border-background-200 bg-background-50 p-3">
          {NAV_LINKS.map((item) => (
            <button
              key={item.href}
              type="button"
              onClick={() => go(item.href)}
              className="cursor-pointer rounded-xl px-4 py-2.5 text-left text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}